import { DateTime } from 'luxon';
import {
    isUnlimitedToDate,
    Parser,
    unlimitedFromDate,
    unlimitedToDate,
} from 'dg-web-shared/lib/Date.ts';
import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { getOrElse, isDefined } from 'dg-web-shared/lib/MaybeV2.ts';
import * as ClearanceEditState from '../state/ClearanceEditState.ts';
import { ToDatePickerSlideIn } from './Shared.tsx';

export function ClearanceEditValidityToDateSlideIn() {
    const { storeState, update } = useStore(store => ({
        edit: ClearanceEditState.Edit.get(store),
        server: ClearanceEditState.Server.get(store),
        layout: ClearanceEditState.Layout.get(store),
    }));
    const { language } = useLanguage();

    const server = storeState.server.data;
    const validTo = getOrElse(
        storeState.edit.validTo,
        isDefined(server)
            ? Parser.isoToDateTime(server.validTo)
            : unlimitedToDate,
    );
    const validFrom = getOrElse(
        storeState.edit.validFrom,
        isDefined(server)
            ? Parser.isoToDateTime(server.validFrom)
            : unlimitedFromDate,
    );
    return (
        <ToDatePickerSlideIn
            open={!!storeState.layout.toDatePickerOpen}
            onClose={() =>
                update(store =>
                    ClearanceEditState.Layout.stateWrite(store, {
                        toDatePickerOpen: false,
                    }),
                )
            }
            validTo={isUnlimitedToDate(validTo) ? null : validTo}
            validFrom={validFrom}
            onSelect={(selectedDate: DateTime) =>
                update((s: Store): string => {
                    ClearanceEditState.Edit.stateWrite(s, {
                        validTo: selectedDate,
                    });
                    ClearanceEditState.Layout.stateWrite(s, {
                        toDatePickerOpen: false,
                    });
                    return 'ClearanceEditValidityToDateSlideIn-setDate';
                })
            }
            language={language}
        />
    );
}
